import BaseEnum from '@linc-technologies/linced-common/enums/base-enum';

export default BaseEnum.create({
  values: [
    { value: 1, label: 'Hero File' },
    { value: 2, label: 'CSV File' },
    { value: 3, label: 'API' },
  ],
});
